import React from "react";
import {formatDateAndTime, projectName} from "../../../resources/constants";

export default function Footer() {
    return (
        <></>
    );
}
